import { API, METHODS } from '../../constants';
import { fetchData } from '../common/apiCalling';
import { constructURL } from '../common';

export const getComplianceStatusCards = async ({ account_id, limit, offset, search } = {}) => {
  const url = constructURL(API.COMPLIANCE_STATUS, {
    account_id: account_id || undefined,
    limit: limit || undefined,
    offset: offset || undefined,
    search: search ? encodeURIComponent(search) : undefined
  });
  return fetchData({ method: METHODS.GET, url });
};

export const getComplianceThresholds = async () => {
  const url = `${API.COMPLIANCE}/thresholds`;
  return fetchData({ method: METHODS.GET, url });
};


